<template>
    <div class="event-list">
        <template v-if="events.length > 0">
            <div :key="event.id_event" v-for="(event, index) in events">
                <p class="month-marker mt-3" v-if="checkForChangingDate(index) && showDateMarker">
                    {{ event.event_start | date('MMMM YYYY') }}
                </p>
                <list-entry
                    class="my-1"
                    :subtitle="parseEventSubtitle(event)"
                    :entity="event"
                    :click-action="openEvent"
                    :default-image="defaultImage"
                >
                    <template #title>
                        <span :class="{'font-italic': event.mandatory, inactive: event.status < 1}">{{ event.title }}</span>
                        <badge v-if="!$is('event.left', event)" v-bind="getEventBadge(event)" class="ml-1"/>
                    </template>

                    <template #right-area v-if="showMemberCount">
                        <div class="member-count d-flex align-items-center">
                            <div class="member-count-text">{{ parseMemberCount(event) }}</div>
                            <icon class="ml-1" name="account-multiple"/>
                        </div>
                    </template>
                </list-entry>
            </div>
        </template>
        <template v-else>
            <p>Du hast derzeit keine Termine.</p>
        </template>
    </div>
</template>

<style lang="scss">
    .event-list {
        .inactive {
            color: $gray-500;
            &:hover {
                color: $dark-red;
            }
        }

        .member-count {
            color: $gray-600;

            .member-count-text {
                font-size: 14px;
                white-space: nowrap;
            }
        }
    }
</style>

<script>
    import moment from "moment";
    import Event from "$src/models/eventModel";

    export default {
        name: "EventList",

        data() {
            return {
                defaultImage: '/img/event.jpg',
            };
        },

        props: {
            events: {type: Array, default: () => []},
            totalCount: {type: Number, default: 0},
            offset: {type: Number, default: 0},
            showDateMarker: {type: Boolean, default: false},
            showMemberCount: {type: Boolean, default: false},
        },

        computed: {
            country_state() {
                return this.$select('country_state').reduce(function(map, obj) {
                    map[obj.key] = obj.label;
                    return map;
                }, {});
            },
        },

        methods: {
            getEventBadge(event) {
                if (this.$is('event.member', event) || this.$is('event.admin', event)) {
                    return {
                        icon: "check-circle-outline",
                        theme: "success",
                        text: "Zugesagt",
                    };
                }
                if (this.$is('event.waiting', event)) {
                    return {
                        icon: "clock-outline",
                        theme: "warning",
                        text: "Warteliste",
                    };
                }
            },

            openEvent(event) {
                if (event.id_event) {
                    this.$ui.pushRoute("community_event", {id_event: event.id_event});
                }
            },

            checkForChangingDate(indexEvent) {
                if (indexEvent == 0) {
                    return true;
                }

                let currentDate = moment(this.events[indexEvent].event_start);
                let lastDate = moment(this.events[indexEvent - 1].event_start);

                if (currentDate.isSame(lastDate, 'month')) {
                    return false;
                } else {
                    return true;
                }
            },

            parseEventSubtitle(event) {
                let result = Event.dateStringFormat(event);
                if (this.country_state.hasOwnProperty(event.country_state)) {
                    result += ", " + this.country_state[event.country_state];
                }
                if (event.location) {
                    result += ", " + event.location;
                }
                if (event.user_count && event.user_count.hasOwnProperty(Event.roleName.member) && event.user_count[Event.roleName.member] > 0) {
                    result += ", " + event.user_count[Event.roleName.member] + " Teilnehmer";
                }
                return result;
            },

            parseMemberCount(event) {
                return `${event.user_count[Event.roleName.member]} / ${event.member_limit}`;
            },
        },
    };
</script>